import React from 'react';
import StrawberryPickingSite from './StrawberryPickingSite';

function App() {
  return <StrawberryPickingSite />;
}

export default App;